export default __webpack_public_path__ + "static/media/icon-api.74c8ad17.svg";